import dayjs from "dayjs";

export function uniqBy (arr, predicate) {
  const cb = typeof predicate === 'function' ? predicate : (o) => o[predicate];

  return [...arr.reduce((map, item) => {
    const key = (item === null || item === undefined) ?
      item : cb(item);

    map.has(key) || map.set(key, item);

    return map;
  }, new Map()).values()];
}

export function groupBy(xs, getter) {
  return xs.reduce(function(rv, x) {
    let key;

    if (getter instanceof Function){
      key = getter(x);
    } else {
      key = x[getter];
    }

    (rv[key] = rv[key] || []).push(x);
    return rv;
  }, {});
};

export function avatarUrl(thread) {
  let {link} = thread;

  if (link.data && link.data.user && link.data.user.avatar_hd) {
    return link.data.user.avatar_hd;
  }

  if (link.media && link.media.avatar_url) {
    return link.media.avatar_url;
  }
}

export function mediaName(thread) {
  let {link} = thread;
  let {media, url} = link;

  if (media && media.name) {
     return media.name;
  }

  if (link.data && link.data.user && link.data.user.screen_name) {
    return '@' + link.data.user.screen_name;
  }

  if (link.url.search('https://mp.weixin.qq.com') !== -1 && link.source) {
      return link.source;
  }

  let parsed = new URL(url);
  let mediaDisplay = media ? media.name : parsed.hostname;
  return mediaDisplay;
}

const ONE_DAY_MSECONDS = 24 * 3600 * 1000;

export function readableDateTime(dateString){
  let day = dayjs(dateString);
  let now = dayjs();

  if (day >= now.startOf('day')){
    return day.fromNow()
  }

  return day.fromNow();
}

export function readableDate(dateString){
  let day = dayjs(dateString);
  let now = dayjs();
  let today = now.startOf('day');

  if (day >= today){
    return '今天';

  } else if (day + ONE_DAY_MSECONDS >= today){
    return '昨天'

  } else if (day + ONE_DAY_MSECONDS * 2 >= today){
    return '前天'
  }

  return dayjs(dateString).fromNow();
}
